export enum FilterType {
  STRING = 'string',
  NUMBER = 'number',
  DATE = 'date',
  DATE_RANGE = 'date-range',
  SELECT = 'select',
  SELECT_ASYNC = 'select-async',
  NONE = 'none'
}
